<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-10-26 13:41:34
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-11-10 11:00:49
 * @FilePath: /chaoyongtuan/src/views/shopManage/commercialHigh/components/myPromonteGoods/tableCells/goodsData.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div>
        <div class="fz-12 font-h6-regular text-color">订单量：{{ row.orderNum | formatEmpty | formatPrice2  }}</div>
        <div class="fz-12 font-h6-regular text-color">销售额：{{ row.totalAmount| formatEmpty | formatPrice2  }}</div>
    </div>
</template>
<script>
import mixin from '@/components/tableCells/mixin.js';
export default{
    mixins: [mixin],
    data(){
        return{}
    }
}
</script>
<style lang="less" scoped>
.text-color{
    color: @color-gy9;
}
</style>